// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2HI59","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__c2Alt"};